import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import QuizLanding from './components/QuizLanding';
import QuizQuestion from './components/QuizQuestion';
import QuizForm from './components/QuizForm';
import QuizResults from './components/QuizResults';
import Header from './components/Header';
import Footer from './components/Footer';
import LoadingScreen from './components/LoadingScreen';
import MetaPixel from './components/MetaPixel';
export function App() {
  const [answers, setAnswers] = useState({});
  const [userInfo, setUserInfo] = useState({
    name: 'Användare',
    email: ''
  });
  return <HelmetProvider data-id="element-0">
      <Helmet data-id="element-1">
        <title data-id="element-2">Hjärnkraft - Testa ditt minne</title>
        <meta name="description" content="Testa ditt minne och upptäck hur du kan förbättra din hjärnhälsa med Hjärnkraft." data-id="element-3" />
      </Helmet>
      <MetaPixel data-id="element-4" />
      <Router data-id="element-5">
        <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-6">
          <Header data-id="element-7" />
          <main className="flex-grow" data-id="element-8">
            <Routes data-id="element-9">
              <Route path="/" element={<QuizLanding data-id="element-11" />} data-id="element-10" />
              <Route path="/quiz/:questionId" element={<QuizQuestion answers={answers} setAnswers={setAnswers} data-id="element-13" />} data-id="element-12" />
              <Route path="/loading" element={<LoadingScreen data-id="element-15" />} data-id="element-14" />
              <Route path="/form" element={<Navigate to="/results" replace data-id="element-17" />} data-id="element-16" />
              <Route path="/results" element={<QuizResults userInfo={userInfo} answers={answers} data-id="element-19" />} data-id="element-18" />
            </Routes>
          </main>
          <Footer data-id="element-20" />
        </div>
      </Router>
    </HelmetProvider>;
}